import { useSelector } from "react-redux"
import { useCurrentShipmentType } from "../../../../hooks/useCurrentShipmentType";
import { selectCountryList008, selectCountryList199 } from "../../../selectors";

export const useDropdownList = (key) => {
    const { isDMS, isImportShipment } = useCurrentShipmentType()
    return useSelector((state) => {
        if (key === 'procedure') return state.DropDownValues?.addProcedure110;
        if (key === 'addProcedure') return state.DropDownValues?.addProcedure111;
        if (key === 'origin') return isImportShipment ? selectCountryList199(state) : selectCountryList008(state);
        return [];
    })
}